(function(){
  /* MK 01.10.2026 : adresses et noms traduits des collections Men / Women / Season One (window.MK_GC, layout/theme.liquid) ; en anglais = valeurs d'origine */
  var GC = window.MK_GC || {};
  var MEN_URL = GC.men || '/collections/men', WOMEN_URL = GC.women || '/collections/women';
  var MEN = MEN_URL.toLowerCase().replace(/\/$/, ''), WOMEN = WOMEN_URL.toLowerCase().replace(/\/$/, '');
  var S1 = (GC.s1 || '/collections/season-one').toLowerCase().replace(/\/$/, '');
  var S1H = S1.split('/').pop();
  var MENT = String(GC.menT || 'MEN').trim().toUpperCase(), WOMENT = String(GC.womenT || 'WOMEN').trim().toUpperCase();
  /* MK 05.10.2026 : collections Chemises en soie homme / femme (adresses des 6 langues) = meme contexte que MEN / WOMEN */
  var MK_MEN_X = ['silk-shirts-men','chemises-en-soie-homme','camicie-di-seta-uomo','seidenhemden-herren','camisas-de-seda-hombre','camisas-de-seda-homem'];
  var MK_WOMEN_X = ['silk-shirts-women','chemises-en-soie-femme','camicie-di-seta-donna','seidenblusen-damen','camisas-de-seda-mujer','camisas-de-seda-mulher'];
  function mkInX(p, list){ var m = String(p || '').split(/[?#]/)[0].toLowerCase().replace(/\/$/, '').match(/\/collections\/([^\/]+)(\/products\/[^\/]+)?$/); return !!(m && list.indexOf(m[1]) > -1); }
  function setGender(g){
    try { sessionStorage.setItem('mk_gender', g); } catch(e){}
  }

  /* MK: arriving directly on /collections/men or /collections/women (Google, shared link, mobile menu) sets the gender context */
  try {
    var mkPath = (window.location.pathname || '').toLowerCase().replace(/\/$/, '');
    var mkIn = function(base){ return mkPath === base || (mkPath.indexOf(base + '/products/') === 0 && mkPath.slice(base.length + 10).indexOf('/') === -1); };
    if (/\/collections\/men(\/products\/[^\/]+)?$/.test(mkPath) || mkIn(MEN)) setGender('men');
    else if (/\/collections\/women(\/products\/[^\/]+)?$/.test(mkPath) || mkIn(WOMEN)) setGender('women');
    else if (mkInX(mkPath, MK_MEN_X)) setGender('men');
    else if (mkInX(mkPath, MK_WOMEN_X)) setGender('women');
  } catch (e) {}
  document.addEventListener('click', function(e){
    var a = e.target.closest ? e.target.closest('a') : null;
    if (!a) return;
    var href = a.getAttribute('href') || '';
    var hl = href.toLowerCase().replace(/\/$/, '');
    if (href === '/collections/men' || hl === MEN) { setGender('men'); return; }
    if (href === '/collections/women' || hl === WOMEN) { setGender('women'); return; }
    if (mkInX(hl, MK_MEN_X)) { setGender('men'); return; }
    if (mkInX(hl, MK_WOMEN_X)) { setGender('women'); return; }
    // Climb through nested <details> ancestors (mega/burger menu uses <details><summary>MEN|WOMEN</summary>...)
    var node = a.closest('details');
    while (node) {
      var summary = node.querySelector(':scope > summary');
      if (summary) {
        var text = (summary.textContent || '').trim().toUpperCase();
        if (text === 'MEN' || text === MENT) { setGender('men'); return; }
        if (text === 'WOMEN' || text === WOMENT) { setGender('women'); return; }
      }
      node = node.parentElement ? node.parentElement.closest('details') : null;
    }
  }, true);

    /* MK-SEASON-ONE-NEUTRE : Season One est neutre de bout en bout */
  function mkRememberCollection(){
    try {
      var p = (window.location.pathname || '').toLowerCase();
      if (p.indexOf('/products/') > -1) return;
      var m = p.match(/\/collections\/([^\/]+)/);
      if (m) sessionStorage.setItem('mk_ctx', m[1]);
    } catch (e) {}
  }
  function mkIsSeasonOne(){
    try {
      if (document.body && document.body.classList.contains('template-collection-season-one')) return true;
      var p = (window.location.pathname || '').toLowerCase();
      /* MK 26.09.2026 : /collections/men|women/products/... (liens IG grid, cartes des collections) = contexte homme/femme */
      if (/\/collections\/(men|women)\/products\//.test(p) || p.indexOf(MEN + '/products/') === 0 || p.indexOf(WOMEN + '/products/') === 0) return false;
      if (p.indexOf('/collections/season-one') > -1 || p.indexOf(S1) === 0) return true;
      if (p.indexOf('/products/') > -1) {
        var ref = (document.referrer || '').toLowerCase();
        if (ref.indexOf('/collections/season-one') > -1 || ref.indexOf(S1) > -1) return true;
        if (ref.indexOf('/collections/') > -1) return false;
        var ctx = null;
        try { ctx = sessionStorage.getItem('mk_ctx'); } catch (e2) {}
        if (ctx === 'season-one' || ctx === S1H) return true;
      }
    } catch (e) {}
    return false;
  }

  function applyFilter(){
    mkRememberCollection();
    if (mkIsSeasonOne()) return;
    var gender;
    try { gender = sessionStorage.getItem('mk_gender'); } catch(e){ gender = null; }
    if (gender !== 'men' && gender !== 'women') return;
    /* MK 26.09.2026 : étiquettes de collection (fil d'Ariane, cartes Style with) = MEN ou WOMEN selon le mode ; en neutre, le Liquid affiche SEASON ONE */
    document.querySelectorAll('[data-mk-gender-label]').forEach(function(el){
      el.textContent = gender === 'men' ? MENT : WOMENT;
      if (el.tagName === 'A') el.setAttribute('href', gender === 'men' ? MEN_URL : WOMEN_URL);
    });
    /* THE FIT: Men shows only the male model line, Women only the female one (Season One keeps both) */
    var mkFitBoxes = [];
    document.querySelectorAll('[data-mk-fit]').forEach(function(el){
      var g = el.getAttribute('data-mk-fit');
      if ((gender === 'men' && g === 'women') || (gender === 'women' && g === 'men')) {
        var box = el.closest('.mk-accordion__item');
        if (box && mkFitBoxes.indexOf(box) < 0) mkFitBoxes.push(box);
        el.remove();
      }
    });
    /* MK 3 oct. 2026 (K) : si la fiche n'a pas de ligne mannequin pour ce mode, on retire THE FIT au lieu de laisser un bloc vide */
    mkFitBoxes.forEach(function(box){
      var c = box.querySelector('.mk-accordion__content');
      if (!box.querySelector('[data-mk-fit]') && (!c || !c.textContent.trim())) box.remove();
    });
    var tags = document.querySelectorAll('.mk-media-tag');
    tags.forEach(function(tag){
      var inMen = tag.getAttribute('data-mk-men') === 'true';
      var inWomen = tag.getAttribute('data-mk-women') === 'true';
      var hide = false;
      if (gender === 'men' && inWomen && !inMen) hide = true;
      if (gender === 'women' && inMen && !inWomen) hide = true;
      if (hide) {
        var mediaEl = tag.nextElementSibling;
        if (mediaEl) mediaEl.remove();
      }
      tag.remove();
    });
    if (tags.length) mkRefreshSliders();
  }

  /* MK: photos removed by the men/women filter must also leave the photo sliders
     (collection cards + product gallery), otherwise the slider keeps empty white slides at the end */
  function mkRefreshSliders(){
    document.querySelectorAll('.swiper').forEach(function(el){
      var s = el.swiper;
      if (!s || s.destroyed) return;
      try {
        s.update();
        if (s.pagination && s.pagination.render) { s.pagination.render(); s.pagination.update(); }
        if (s.navigation && s.navigation.update) s.navigation.update();
        if (s.activeIndex > s.slides.length - 1) s.slideTo(Math.max(0, s.slides.length - 1), 0);
      } catch (e) {}
    });
  }
  window.mkRefreshSliders = mkRefreshSliders;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFilter);
  } else {
    applyFilter();
  }
  /* Sliders created after the filter already count the right photos; refresh once more after load for safety */
  window.addEventListener('load', function(){ setTimeout(mkRefreshSliders, 50); });

  /* Products added later (filters, sorting, load more, recently viewed) carry their own tags: filter them too */
  try {
    var mkTimer = null;
    new MutationObserver(function(muts){
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1 && (n.classList.contains('mk-media-tag') || n.querySelector('.mk-media-tag') || n.hasAttribute('data-mk-gender-label') || n.querySelector('[data-mk-gender-label]'))) {
            clearTimeout(mkTimer);
            mkTimer = setTimeout(function(){ applyFilter(); setTimeout(mkRefreshSliders, 60); }, 30);
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();
